import { ActionTree, Module, MutationTree } from "vuex";
import { UserState, RootState } from "../type";
import { GetterTree } from "vuex";
import { apiLogin, apiAdminInfo } from "@/api/app";

// State
const state: UserState = {
  userInfo: {},
  token: null,
  permissions: [],
};

// Getters
const getters: GetterTree<UserState, RootState> = {
  // 获取Token
  token: (state) => state.token || null,
  userInfo: (state) => state.userInfo || null,
};

// Mutations
const mutations: MutationTree<UserState> = {
  // 设置用户信息
  setUserInfo: (state, payload): void => {
    state.userInfo = payload;
  },

  // 清除用户信息
  clearUserInfo: (state): void => {
    state.userInfo = {};
    state.token = null;
  },

  // 设置Token
  setToken: (state, payload): void => {
    state.token = payload;
  },

  setPermissions(state, permissions: any) {
    state.permissions = permissions || [];
  },
};

// Actions
const actions: ActionTree<UserState, RootState> = {
  login({ commit }, data) {
    const { account, password } = data;
    return new Promise((resolve, reject) => {
      apiLogin({
        account,
        password,
        terminal: 1,
      })
        .then((data: any) => {
          commit("setToken", data.token);
          resolve(data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  // 获取管理员信息
  getUser({ commit }) {
    return new Promise((resolve, reject) => {
      apiAdminInfo()
        .then((data: any) => {
          commit("setUserInfo", data);
          resolve(data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
};

const user: Module<UserState, RootState> = {
  state,
  mutations,
  actions,
  getters,
};

export default user;
